import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Academy from './pages/Academy';
import Select from './pages/Select';
import Registration from './pages/Registration';
import Fees from './pages/Fees';
import Store from './pages/Store';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Sponsors from './pages/Sponsors';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App d-flex flex-column min-vh-100">
        <Navigation />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/select" element={<Select />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/store" element={<Store />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/sponsors" element={<Sponsors />} />
          </Routes>
        </main>
        
        {/* Sponsors CTA */}
        <section className="bg-light py-5 border-top">
            <div className="container text-center">
                <h5 className="text-navy fw-bold mb-3 text-uppercase">Partner With Us</h5>
                <p className="text-muted mb-4">Help us remove barriers to youth sports. Become a 515 Soccer Academy sponsor today.</p>
                <div className="d-flex justify-content-center gap-3">
                    <Link to="/sponsors" className="btn btn-outline-primary">View Sponsorship Opportunities</Link>
                </div>
            </div>
        </section>

        <footer className="bg-navy text-white text-center py-4">
          <div className="container">
            <div className="mb-3">
              <Link to="/" className="text-white-50 text-decoration-none mx-2">Home</Link>
              <Link to="/about" className="text-white-50 text-decoration-none mx-2">About</Link>
              <Link to="/contact" className="text-white-50 text-decoration-none mx-2">Contact</Link>
              <Link to="/sponsors" className="text-white-50 text-decoration-none mx-2">Sponsors</Link>
              <span className="text-white-50 mx-2">|</span>
              <Link to="/privacy" className="text-white-50 text-decoration-none mx-2">Privacy Policy</Link>
              <Link to="/terms" className="text-white-50 text-decoration-none mx-2">Terms of Use</Link>
            </div>
            <p className="mb-0 small">&copy; {new Date().getFullYear()} 515 Soccer Academy. All rights reserved.</p>
            <small className="text-info">Champions Do Extra.</small>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;